{
  "errors": {
    "messages": {
      "blank": "can't be blank",
      "required": "is required",
      "mustExist": "is required",
      "invalid": "is invalid",
      "taken": "is already taken",
      "notANumber": "is not a number",
      "tooShort": "is too short",
      "tooLong": "is too long",
      "greaterThan": "must be greater",
      "lessThan": "must be less"
    },
    "fields": {
      "general_info_entries": "Entry",
      "general_info_entry_additional_retentions": "Additional retention",
      "report_entries": "Entry",
      "report_entry_days": "Day",
      "report_entry_day_events": "Event",
      "payroll_entries": "Entry",
      "payroll_entry_days": "Day",
      "payroll_entry_day_additional_retentions": "Additional retention",
      "order_references": "Reference",
      "order_print_inks": "Ink",
      "order_mix_entries": "Mix",
      "extrusion_orders": "Order",
      "employee": "Employee"
    }
  },
  "common": {
    "save": "Save",
    "saveAndContinue": "Save & Continue",
    "saving": "Saving…",
    "cancel": "Cancel",
    "clear": "Clear",
    "delete": "Delete",
    "deleting": "Deleting…",
    "edit": "Edit",
    "new": "New",
    "duplicate": "Duplicate",
    "copy": "Copy",
    "copied": "Copied!",
    "downloadExcel": "Download Excel",
    "downloadError": "The file could not be generated. Please try again.",
    "loadError": "The data could not be loaded. Please try again.",
    "excel": "Excel",
    "search": "Search…",
    "reload": "Reload",
    "back": "Back",
    "home": "Home",
    "add": "Add",
    "noData": "No data found.",
    "name": "Name",
    "date": "Date",
    "updatedAt": "Updated At",
    "id": "ID",
    "deleteCannotUndo": "This action cannot be undone.",
    "loading": "Loading…",
    "export": "Export {{count}} / {{total}}",
    "startDate": "Start Date",
    "endDate": "End Date",
    "noDataRange": "No data for the selected range.",
    "reports": "Reports",
    "total": "Total",
    "employee": "Employee",
    "generalInfo": "General Info",
    "reportDate": "Report Date",
    "remove": "Remove",
    "removeEntry": "Remove entry",
    "addEntry": "Add Entry",
    "entries": "Entries",
    "noEntries": "No entries yet.",
    "days": "Days",
    "addDay": "Add Day"
  },
  "nav": {
    "signedInAs": "Signed in as",
    "oldDashboard": "Old Dashboard",
    "logout": "Logout",
    "lightMode": "Light mode",
    "darkMode": "Dark mode",
    "switchToSpanish": "Español",
    "switchToEnglish": "English"
  },
  "home": {
    "title": "Home",
    "subtitle": "Select a module to get started.",
    "humanResources": "Human Resources",
    "production": "Production",
    "system": "System",
    "isNew": "New"
  },
  "auth": {
    "login": "Login",
    "selectSignIn": "Select how you want to sign in",
    "admCloud": "ADM Cloud",
    "admCloudDesc": "Sign in with your ADM Cloud credentials.",
    "system": "System",
    "systemDesc": "Sign in with your system credentials.",
    "email": "Email",
    "password": "Password",
    "signIn": "Sign in",
    "signingIn": "Signing in...",
    "comingSoon": "Coming soon",
    "or": "OR"
  },
  "modules": {
    "employees": "Employees",
    "employeesDesc": "Manage employees",
    "generalInfo": "General Info",
    "generalInfoDesc": "Manage employee payments and retentions",
    "weeklyReport": "Weekly Report",
    "weeklyReportDesc": "Manage weekly reports",
    "payrolls": "Payrolls",
    "payrollsDesc": "Manage employee payrolls",
    "orders": "Orders",
    "ordersDesc": "Manage manufacturing orders",
    "extrusion": "Extrusion",
    "extrusionDesc": "Manage extrusion production schedule",
    "exports": "Exports",
    "exportsDesc": "Export report grouped by client with order synchronization.",
    "history": "History",
    "historyDesc": "Browse all changes recorded across the system"
  },
  "employees": {
    "title": "Employees",
    "new": "New Employee",
    "noData": "No employees found.",
    "fpcId": "FPC ID",
    "fullName": "Name",
    "group": "Group",
    "department": "Department",
    "position": "Position",
    "joinDate": "Join Date",
    "deleteTitle": "Delete Employee",
    "deleteText": "Are you sure you want to delete employee {{name}}? This action cannot be undone.",
    "duplicateTitle": "Duplicate Employee",
    "duplicateText": "Duplicate {{name}}? A new record will be created with the same data.",
    "duplicating": "Duplicating...",
    "lastName": "Last Name",
    "groups": {
      "none": "None",
      "administrative": "Administrative",
      "operations": "Operations"
    },
    "departments": {
      "none": "None",
      "administration": "Administration",
      "production": "Production"
    },
    "positions": {
      "none": "None",
      "generalManager": "General Manager",
      "administrativeAssistant": "Administrative Assistant",
      "receptionist": "Receptionist",
      "operationsSupervisor": "Operations Supervisor",
      "extruderOperator": "Extruder Operator",
      "flexoOperator": "Flexo Operator",
      "cutOperator": "Cut Operator",
      "operator": "Operator",
      "concierge": "Concierge"
    },
    "form": {
      "firstName": "First Name",
      "secondName": "Second Name",
      "firstLastName": "First Last Name",
      "secondLastName": "Second Last Name",
      "identity": "Identity",
      "group": "Group",
      "department": "Department",
      "position": "Position",
      "joinDate": "Join Date",
      "fpcId": "FPC ID",
      "salary": "Salary",
      "bankAccount": "Bank Account",
      "bank": "Bank",
      "afp": "AFP",
      "tss": "TSS",
      "newEmployee": "New Employee",
      "editEmployee": "Edit Employee",
      "none": "None"
    }
  },
  "generalInfos": {
    "title": "General Info",
    "new": "New",
    "noData": "No general infos found.",
    "reportDate": "Report Date",
    "deleteTitle": "Delete General Info",
    "deleteText": "Are you sure you want to delete {{name}}? This action cannot be undone.",
    "duplicateTitle": "Duplicate General Info",
    "duplicateText": "Duplicate {{name}}? A new record will be created with the same data.",
    "duplicating": "Duplicating...",
    "form": {
      "editTitle": "Edit General Info",
      "newTitle": "New General Info",
      "backTooltip": "Back to General Info",
      "salary": "Salary",
      "dailySalary": "Daily Salary",
      "yearlySalary": "Yearly Salary",
      "benefits": "Benefits",
      "vacations": "Vacations",
      "vacationsBonus": "Vacation Bonus",
      "easterRoyalty": "Easter Royalty",
      "firstBonus": "First Bonus",
      "secondBonus": "Second Bonus",
      "totalBonus": "Total Bonus",
      "employeeRetentions": "Employee Retentions",
      "employerPayments": "Employer Payments",
      "removeRetention": "Remove retention",
      "addRetention": "Add Retention",
      "active": "Active",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "amount": "Amount",
      "description": "Description",
      "yrs": "yrs",
      "noEmployeeSelected": "No employee selected",
      "noEntries": "No entries yet. Click \"Add Entry\" to get started.",
      "afpRetention": "AFP (2.87%)",
      "sfsRetention": "SFS (3.04%)",
      "contributionRetention": "Contribution (5.91%)",
      "afpPayment": "AFP (7.10%)",
      "sfsPayment": "SFS (7.09%)",
      "arlPayment": "ARL (1.10%)",
      "infotepPayment": "INFOTEP (1%)",
      "contributionPayment": "Contribution (16.29%)",
      "tssPayment": "TSS (22.20%)"
    }
  },
  "weeklyReports": {
    "title": "Weekly Reports",
    "new": "New",
    "noData": "No weekly reports found.",
    "reportDate": "Report Date",
    "deleteTitle": "Delete Weekly Report",
    "deleteText": "Are you sure you want to delete {{name}}? This action cannot be undone.",
    "duplicateTitle": "Duplicate Weekly Report",
    "duplicateText": "Duplicate {{name}}? A new record will be created with the same data.",
    "duplicating": "Duplicating...",
    "monthlyLog": "Monthly Log",
    "parseTimecard": "Parse Timecard",
    "generateExcel": "Generate Excel",
    "monthlyLogTitle": "Monthly Log",
    "form": {
      "editTitle": "Edit Weekly Report",
      "newTitle": "New Weekly Report",
      "backTooltip": "Back to Weekly Reports",
      "start": "Start",
      "end": "End",
      "holiday": "Holiday",
      "addEvent": "Add Event",
      "addDay": "Add Day",
      "removeDay": "Remove day",
      "addDayNoRange": "Set a valid Start Date and End Date for the report first.",
      "addDayRangeFull": "Every day between the Start Date and End Date is already added.",
      "singleEventWarning": "Only one punch in/out event is registered.",
      "missingTimesError": "One or more events are missing a Start or End time.",
      "invalidTimeRangeError": "One or more events end at or before their start time; they count as zero hours.",
      "noEmployee": "No employee",
      "tabEmployees": "Employees",
      "tabHours": "Hours",
      "tabDetails": "Details",
      "noEntries": "No entries yet.",
      "noEvents": "No events.",
      "daily": "Daily",
      "hourly": "Hourly",
      "extraHrs": "Extra Hrs",
      "doubleHrs": "Double Hrs",
      "nightHrs": "Night Hrs",
      "punchIn": "Punch In",
      "punchOut": "Punch Out",
      "regularHrs": "Regular Hrs",
      "weekHours": "Week Hours",
      "generating": "Generating…",
      "downloadExcel": "Download Excel"
    },
    "monthlyLogPage": {
      "backTooltip": "Back to Weekly Reports",
      "monthAndYear": "Month & Year",
      "workedHrs": "Worked Hrs",
      "extraHrs": "Extra Hrs",
      "doubleHrs": "Double Hrs",
      "noData": "No reports found for {{month}}"
    }
  },
  "payrolls": {
    "title": "Payrolls",
    "new": "New",
    "noData": "No payrolls found.",
    "payrollDate": "Date",
    "deleteTitle": "Delete Payroll",
    "deleteText": "Are you sure you want to delete {{name}}? This action cannot be undone.",
    "duplicateTitle": "Duplicate Payroll",
    "duplicateText": "Duplicate {{name}}? A new record will be created with the same data.",
    "duplicating": "Duplicating...",
    "form": {
      "newTitle": "New Payroll",
      "editTitle": "Edit Payroll",
      "loanRetentions": "Loan Retentions ({{count}})",
      "loanRetention": "Loan Retention",
      "active": "Active",
      "removeDay": "Remove day",
      "extraHoursSalary": "Extra Hours Salary",
      "customTotal": "Custom total",
      "daysCount": "{{count}} days",
      "noDays": "No days yet. Click \"Add Day\" to add one.",
      "noEntries": "No entries yet. Click \"Add Entry\" to add one.",
      "salary": "Salary",
      "dailySalary": "Daily Salary",
      "otherDed": "Other Ded.",
      "totalDed": "Total Ded.",
      "additional": "Additional",
      "inactiveSuffix": " (INACTIVE)",
      "moveUp": "Move up",
      "moveDown": "Move down"
    }
  },
  "extrusion": {
    "title": "Extrusion",
    "new": "New Entry",
    "noData": "No entries found.",
    "ordersCount": "Orders",
    "deleteTitle": "Delete Extrusion",
    "deleteText": "Are you sure you want to delete {{code}}? This action cannot be undone.",
    "form": {
      "newTitle": "New Extrusion",
      "editTitle": "Edit Extrusion",
      "code": "Code",
      "codeRequired": "Code is required.",
      "date": "Date",
      "version": "Version",
      "ordersSection": "Orders",
      "addOrders": "Add orders",
      "materialColor": "Material Color",
      "reference": "Reference",
      "kilos": "Kgs.",
      "units": "Units",
      "entryDate": "Entry Date",
      "noOrders": "No orders assigned.",
      "picker": {
        "title": "Add orders",
        "search": "Search (code, client, project, reference)",
        "entryDate": "Entry month",
        "status": "Status",
        "paperColor": "Material Color",
        "allStatuses": "All statuses",
        "allColors": "All colors",
        "selectedCount": "{{count}} selected",
        "selectedCount_other": "{{count}} selected",
        "addCount": "Add {{count}}",
        "noResults": "No orders found.",
        "loadError": "Failed to load orders.",
        "retry": "Retry"
      }
    }
  },
  "orders": {
    "title": "Orders",
    "new": "New",
    "noData": "No orders found.",
    "code": "Code",
    "client": "Client",
    "project": "Project",
    "inExport": "In Export",
    "openExport": "Open Export",
    "references": "References",
    "product": "Product",
    "color": "Color",
    "paperColor": {
      "white": "White"
    },
    "progKgs": "Prog. Kgs",
    "totalKgs": "Total Kgs",
    "status": "Status",
    "statuses": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "deleteTitle": "Delete Order",
    "deleteText": "Are you sure you want to delete order {{code}}? This action cannot be undone.",
    "form": {
      "newOrder": "New Order",
      "clientInfo": "Client Info",
      "code": "Code",
      "date": "Date",
      "entryDate": "Entry date",
      "client": "Client",
      "project": "Project",
      "location": "Location",
      "city": "City",
      "status": "Status",
      "addReference": "Add Reference",
      "reference": "Reference",
      "refName": "Name",
      "paper": "Paper",
      "width": "Width (cms)",
      "height": "Height (cms)",
      "grammage": "Grammage",
      "sides": "Sides",
      "bellows": "Bellows",
      "generalInfo": "General Info",
      "weightPerRoll": "Weight/Roll (Kgs)",
      "weightPerCore": "Weight/Core (Kgs)",
      "requestedAmount": "Requested Amount",
      "wastePercent": "Waste %",
      "refilePercent": "Refile %",
      "minThousandWeight": "Min. Thousand Weight",
      "maxThousandWeight": "Max. Thousand Weight",
      "programmedKgs": "Programmed Kgs",
      "waste": "Waste",
      "refile": "Refile",
      "total": "Total",
      "rolls": "Rolls",
      "extrusion": "Extrusion",
      "extruderNo": "Extruder No.",
      "mold": "Mold (mm)",
      "widthFormula": "Width Formula",
      "widthCms": "Width (cms)",
      "bellowsCms": "Bellows (cms)",
      "pigment": "Pigment",
      "treatment": "Treatment",
      "treatmentType": "Treatment Type",
      "minWidth": "Min. Width",
      "maxWidth": "Max. Width",
      "caliber": "Caliber",
      "minCaliber": "Min. Caliber",
      "maxCaliber": "Max. Caliber",
      "primaryMix": "Primary Mix",
      "secondaryMix": "Secondary Mix",
      "addTo": "Add to {{section}}",
      "item": "Item",
      "loadingItems": "(loading…)",
      "itemsLoadError": "Could not load items from ADM Cloud. Please refresh the page.",
      "physicalCount": "Physical Count",
      "physicalCountsLoadError": "Could not load physical counts from ADM Cloud. Please refresh the page.",
      "createNewPhysicalCount": "Create new physical count",
      "physicalCountRequiresMix": "Add at least one item to a mix first",
      "sealing": "Sealing",
      "sideBellows": "Side Bellows (cms)",
      "bottomBellows": "Bottom Bellows (cms)",
      "sideSeal": "Side Seal",
      "bottomSeal": "Bottom Seal",
      "doubleBottomSeal": "Double Bottom Seal",
      "bottomCut": "Bottom Cut",
      "length": "Length",
      "minLength": "Min. Length",
      "maxLength": "Max. Length",
      "packaging": "Packaging",
      "boxes": "Boxes",
      "amountPerPkg": "Amount / Pkg.",
      "pkgsPerMasterCase": "Pkgs. / Master Case",
      "amountPerMasterCase": "Amount / Master Case",
      "masterCaseCount": "Master Case Count",
      "printing": "Printing",
      "printerNo": "Printer No.",
      "inksAmount": "Inks Amount",
      "roller": "Roller",
      "mounting": "Mounting",
      "threaded": "Threaded",
      "rollsNo": "Rolls No.",
      "kgPerRoll": "Kg. per Roll",
      "mtPerRoll": "Mt. per Roll",
      "noInk": "No Ink",
      "noRoller": "No roller",
      "noMounting": "No mounting",
      "noThreaded": "No threaded",
      "sideA": "Side A",
      "sideB": "Side B",
      "addInk": "Add Ink",
      "comment": "Comment",
      "none": "None",
      "back": "Back",
      "color": {
        "na": "N/A",
        "white": "White",
        "kraft": "Kraft"
      },
      "ink": {
        "noInk": "No Ink",
        "oneInk": "1 Ink",
        "twoInks": "2 Inks",
        "threeInks": "3 Inks",
        "fourInks": "4 Inks"
      }
    },
    "reports": {
      "title": "Reports",
      "perClient": "Per Client",
      "perProduct": "Per Product",
      "monthly": "Monthly",
      "monthAndYear": "Month & Year",
      "clientHeader": "Client",
      "productHeader": "Product",
      "ordersCount": "Orders",
      "paperColor": "Color",
      "progKgs": "Prog. (Kgs.)",
      "totalKgs": "Total (Kgs.)",
      "noOrders": "No orders for the selected month.",
      "code": "Code",
      "client": "Client",
      "project": "Project",
      "product": "Product",
      "extrusion": "Extrusion",
      "new": "New"
    }
  },
  "export": {
    "new": "New Export",
    "deleteTitle": "Delete Export",
    "deleteText": "Are you sure you want to delete the export \"{{name}}\"?",
    "entriesCount": "Entries",
    "form": {
      "newTitle": "New Export",
      "editTitle": "Edit Export",
      "name": "Name",
      "nameRequired": "Name is required.",
      "client": "Client",
      "updateDate": "Update Date",
      "updateDateRequired": "Update date is required.",
      "entriesSection": "Entries",
      "addEntry": "Add Entry",
      "addFromOrders": "Add from Orders",
      "noEntries": "No entries. Add one to get started.",
      "entry": {
        "opDate": "OP Date",
        "orderNumber": "Order",
        "project": "Project",
        "paperColor": "Paper Color",
        "printingInks": "Printing Inks",
        "kilograms": "Kilograms",
        "artRequest": "Art Req.",
        "plateRequest": "Plate Req.",
        "plateApproval": "Plate Appr.",
        "exportNumber": "Export #",
        "exitDate": "Exit Date",
        "urgent": "Urgent",
        "urgentLabel": "URGENT",
        "unlinkConfirmTitle": "Unlink Order",
        "unlinkConfirmText": "The order \"{{code}}\" will no longer be linked to this entry. Continue?",
        "action": {
          "link": "Link Order",
          "create": "Create Order",
          "unlink": "Unlink",
          "openOrder": "Open Order"
        }
      },
      "tristate": {
        "na": "N/A",
        "yes": "Yes",
        "no": "No"
      },
      "color": {
        "na": "N/A",
        "white": "White",
        "kraft": "Kraft"
      }
    },
    "newOrderDialog": {
      "title": "Create Order",
      "orderCode": "Order Code",
      "orderDate": "Order Date",
      "orderEntryDate": "Entry Date",
      "client": "Client",
      "create": "Create",
      "errorOrderCodeTaken": "Order code is already taken."
    }
  },
  "history": {
    "title": "History",
    "subtitle": "All changes across the system, newest first.",
    "openHistory": "Open history",
    "openRecordHistory": "Open this record's history",
    "filters": {
      "module": "Module",
      "actor": "User",
      "event": "Event",
      "from": "From",
      "to": "To",
      "all": "All",
      "clear": "Clear filters"
    },
    "events": {
      "create": "Created",
      "update": "Updated",
      "destroy": "Deleted",
      "duplicate": "Duplicated"
    },
    "actor": {
      "system": "System"
    },
    "diff": {
      "field": "Field",
      "old": "Before",
      "new": "After",
      "empty": "—"
    },
    "group": {
      "summary": "{{count}} change in this action",
      "summary_other": "{{count}} changes in this action"
    },
    "noEvents": "No history yet.",
    "eventLine": "{{verb}} {{model}} #{{id}}",
    "fields": {
      "fpc_id": "FPC ID",
      "op_date": "OP Date",
      "name": "Name",
      "last_name": "Last Name",
      "join_date": "Join Date",
      "group": "Group",
      "department": "Department",
      "position": "Position",
      "report_date": "Report Date",
      "payroll_name": "Payroll Name",
      "payroll_date": "Payroll Date",
      "amount": "Amount",
      "description": "Description",
      "salary": "Salary",
      "daily_salary": "Daily Salary",
      "yearly_salary": "Yearly Salary",
      "bonus": "Bonus",
      "first_bonus": "First Bonus",
      "second_bonus": "Second Bonus",
      "vacations": "Vacations",
      "vacations_bonus": "Vacations Bonus",
      "easter_royalty": "Easter Royalty",
      "afp_retention": "AFP Retention",
      "sfs_retention": "SFS Retention",
      "contribution_retention": "Contribution Retention",
      "afp_payment": "AFP Payment",
      "sfs_payment": "SFS Payment",
      "arl_payment": "ARL Payment",
      "infotep_payment": "INFOTEP Payment",
      "contribution_payment": "Contribution Payment",
      "tss_payment": "TSS Payment",
      "other_deductions": "Other Deductions",
      "additional_value": "Additional Value",
      "is_custom": "Custom",
      "is_active": "Active",
      "position": "Order",
      "total_amount": "Total Amount",
      "entry_date": "Entry Date",
      "client_id": "Client ID",
      "client_name": "Client Name",
      "project_name": "Project Name",
      "location": "Location",
      "city": "City",
      "order_code": "Order Code",
      "order_number": "Order Number",
      "order_date": "Order Date",
      "reference_number": "Reference Number",
      "color_name": "Color",
      "side": "Side",
      "item_id": "Item ID",
      "item_name": "Item Name",
      "percentage_value": "Percentage",
      "total_value": "Total",
      "mix_type": "Mix Type",
      "code": "Code",
      "version": "Version",
      "date": "Date",
      "update_date": "Update Date",
      "export_id": "Export ID",
      "order_id": "Order ID",
      "kilograms": "Kilograms",
      "paper_color": "Paper Color",
      "printing_inks_amount": "Printing Inks",
      "art_request": "Art Request",
      "plate_request": "Plate Request",
      "plate_approval": "Plate Approval",
      "export_number": "Export #",
      "exit_date": "Exit Date",
      "urgent": "Urgent"
    },
    "models": {
      "Employee": "Employee",
      "GeneralInfo": "General Info",
      "GeneralInfoEntry": "General Info Entry",
      "GeneralInfoEntryAdditionalRetention": "Additional Retention",
      "Report": "Weekly Report",
      "ReportEntry": "Report Entry",
      "ReportEntryDay": "Report Day",
      "ReportEntryDayEvent": "Day Event",
      "Payroll": "Payroll",
      "PayrollEntry": "Payroll Entry",
      "PayrollEntryDay": "Payroll Day",
      "PayrollEntryDayAdditionalRetention": "Additional Retention",
      "Order": "Order",
      "OrderMixEntry": "Mix Entry",
      "OrderPrintInk": "Print Ink",
      "OrderReference": "Reference",
      "Extrusion": "Extrusion",
      "ExtrusionOrder": "Extrusion Order",
      "Export": "Export",
      "ExportEntry": "Export Entry"
    }
  }
}
